var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",staticStyle:{"width":"100%","image-rendering":"optimizespeed"},attrs:{"width":_vm.$store.state.canvasSizeX,"height":_vm.$store.state.canvasSizeY}})])
}
var staticRenderFns = []

export { render, staticRenderFns }